import { StudyType } from "@/api/studio/studies/types/study.type";

/**
 * getStudyTypeCountLabel function
 * Returns the count-label noun for a study type, singular or plural.
 * e.g. getStudyTypeCountLabel("video", 3) => "videos"
 *
 * @param type - The study type ("asset" | "scene" | "video")
 * @param count - The item count, used to decide singular vs plural
 * @returns The noun to show after the count (e.g. "asset", "scenes", "videos")
 */
export const getStudyTypeCountLabel = (type: StudyType = "asset", count: number): string => {
  const noun = type === "scene" ? "scene" : type === "video" ? "video" : "asset";
  return count === 1 ? noun : `${noun}s`;
};
